
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelContacts from "@/views/审核管理/model/DZModelContacts";
import nyMessageToast from "@/utils/NYMessageToast";
import DZServiceDemand from "@/views/审核管理/service/DZServiceDemand";
import DZServiceCourtship from "@/views/审核管理/service/DZServiceCourtship";

@Component
export default class Base extends Vue{

  rules = {
    contactsPhone:[
      { required: true, message: '请输入手机号', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
    ],
    contactsName:[{ required: true, message: '请输入姓名', trigger: 'blur' }]
  }

  @Prop() data;

  @Prop() sign;

  m_contacts = new DZModelContacts();

  flag = true

  serve_demand = new DZServiceDemand();

  serve_courtship = new DZServiceCourtship();

  created() { }

  mounted() { }

  handle_edit(){
    this.flag = !this.flag
  }

  handle_submit(){
    // @ts-ignore
    this.$refs.form.validate((valid,obj) => {
      if(valid){
        this.$emit('ny_submit', this.m_contacts);
        this.handle_edit();
      }else {
        let msg = ""
        for(let key in obj){
          msg += obj[key][0].message + "。"
        }
        nyMessageToast.warning(msg)
        return false
      }
    })

  }

  @Watch("data")
  watchData(value: any, oldValue: string) {
    if(value){
      this.m_contacts = value;
    }
  }

}
